import {observable, action, runInAction} from 'mobx'
import {get} from '../../../../utils/ajax'

class ToolkitStore {
    @observable List;
    @observable page

    constructor() {
        this.List=[]
        this.page = {
            current: 1,
            total: 1,
            search: ''
        }
    }

    /*** 根据条件或无条件分页请求接口加载数据*/
    @action
    initPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.page.current) {
            page = this.page.current - 1
        } else {
            page = 0
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/carseriesCatalog/receptionList`,{
            'page': page.toString(),
            'size': 100
        })
        runInAction(() => {
            this.List = res.content || [];
            this.page = {
                current: res.number + 1,
                total: res.totalElements
            }
        })
    }
}

export default new ToolkitStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/toolkit/Home/store.js